import { FunctionComponent, ReactNode } from "react";

import { FontSizes, LabeledText, useTheme } from "@bps/fluent-ui";

interface ServerMigrationLabeledTextProps {
  label: string;
  labelWidth: number;
  children?: ReactNode;
}

export const ServerMigrationLabeledText: FunctionComponent<ServerMigrationLabeledTextProps> = ({
  label,
  labelWidth,
  children
}) => {
  const theme = useTheme();

  return (
    <LabeledText
      label={label}
      noSemicolon
      wrap
      styles={{
        root: {
          gridTemplateColumns: `${labelWidth}px minmax(0, 1fr)`,
          columnGap: theme.spacing.s1,
          alignItems: "start"
        },
        label: {
          fontSize: FontSizes.medium,
          whiteSpace: "nowrap",
          lineHeight: 24
        },
        // Matches the label's line height so single-line values line up.
        text: { display: "flex", alignItems: "center", minHeight: 24 }
      }}
    >
      {children ?? "--"}
    </LabeledText>
  );
};
